import { zergApi } from "@/service/zerg";

class DocumentOrdersService {

    async saveDocumentOrder(params) {
        try {
            const data = await zergApi.post('/operations/document-orders/save', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDocumentOrders(params) {
        try {
            const data = await zergApi.post('/operations/document-orders/get', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAvailableDocumentOrders(params) {
        try {
            const data = await zergApi.get('/operations/document-orders/get-available-document-orders', { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDocumentOrderById(params) {
        try {
            const data = await zergApi.post('/operations/document-orders/get-document-order-by-id', params);
            return data
        } catch (error) {
            throw error;
        }
    }

    async deleteDocument(params) {
        try {
            const data = await zergApi.post('/operations/document-orders/delete-document', params)
            return data
        } catch (error) {
            throw error;
        }
    }
}

export default new DocumentOrdersService();